import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SubsidiaryService } from '../../services/subsidiary.service';

@Component({
    selector: 'app-update-subsidiary',
    templateUrl: './update-subsidiary.component.html',
    styleUrls: ['./update-subsidiary.component.css']
})

export class UpdateSubsidiaryComponent implements OnInit {

    subsidiaryForm: FormGroup;
    subsidiary: any = [];

    @Input() initialValue: string;
    @Output() modelChange = new EventEmitter();

    id: string;
    createdAt: string;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private service: SubsidiaryService) {
        console.log('Subsidiary');
        
        this.id = activatedRoute.snapshot.paramMap.get('id');

        let subSub = this.service.getSubsidiary(this.id).subscribe(res => {
            this.subsidiary = res;

            this.initialValue = this.subsidiary.companyId;
            this.createdAt = this.subsidiary.createdAt;

            subSub.unsubscribe();
        });
    }

    ngOnInit() {
        this.subsidiaryForm = this.formBuilder.group({
            name: ['', Validators.required],
            description: ['', Validators.required],
            company: ['', Validators.required]
        });
    }

    onSubmit() {
        this.subsidiary = this.saveSubsidiary();

        this.service.putSubsidiary(this.subsidiary, this.id);
        this.router.navigate(['/sub']);
    }

    saveSubsidiary() {
        const currentDate = new Date();

        const saveSubsidiary = {
            active: 1,
            companyId: this.subsidiaryForm.get('company').value,
            createdAt: this.createdAt,
            description: this.subsidiaryForm.get('description').value,
            name: this.subsidiaryForm.get('name').value,
            updatedAt: currentDate
        };

        return saveSubsidiary;
    }

    change(newValue) {
        this.modelChange.emit(newValue);
    }

}
